module.exports = function(h, row) {
    const getTotalDifference = stock => {
        if (this.hasFinalized) {
            return stock.difference;
        }

        if (!stock.counted_quantity) return null;

        const difference =
            parseFloat(stock.counted_quantity) -
            parseFloat(stock.expected_quantity);

        return difference;
    };

    const getFormattedNumber = num => {
        return num !== null ? numeral(num).format('0.00') : null;
    };

    const getDifferenceTextClass = stock => {
        const difference = getTotalDifference(stock);

        if (difference < 0) return 'text-danger';
        if (difference > 0) return 'text-success';

        return '';
    };

    return (
        <span class={getDifferenceTextClass(row)}>
            {getFormattedNumber(getTotalDifference(row))}
        </span>
    );
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/stock_check/counted-stock-columns/difference.jsx